import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Currency} from "../../models/currency";
import Helpers from "../../utils/helpers";

@Injectable()
export class CurrencyControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {}

  public getCurrencies(): Observable<Currency[]> {
    return this.http.get(this.baseUrl + "currency") as Observable<Currency[]>;
  }

  public addCurrency(currency: Currency) {
    Helpers.trimRecursiveObj(currency);
    return this.http.post(this.baseUrl + "currency", currency);
  }

  public editCurrency(currency: Currency) {
    Helpers.trimRecursiveObj(currency);
    return this.http.put(this.baseUrl + "currency/" + currency.id, currency);
  }

  public removeCurrency(currencyId: string) {
    return this.http.delete(this.baseUrl + "currency/" + currencyId, {responseType: "text"});
  }

  public enableCurrency(currency: Currency) {
    return this.http.put(this.baseUrl + "currency/enable/" + currency.id, currency);
  }

  public disableCurrency(currency: Currency) {
    return this.http.put(this.baseUrl + "currency/disable/" + currency.id, currency);
  }

  public getEnabledCurrencies(): Observable<Currency[]> {
    return this.http.get(this.baseUrl + "currency/enabled") as Observable<Currency[]>;
  }

}
